import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatNewsletterPromptService {
  private promptIdSubject = new BehaviorSubject<string>('');

  promptId$ = this.promptIdSubject.asObservable();

  setPromptId(id: string): void {
    this.promptIdSubject.next(id || '');
  }
}
